import { useApClassApi } from "../api/ApClassApiClient";
import { ApClassFrontendService } from "../services/ApClassFrontendService";

export const useApClassService = (): ApClassFrontendService =>
  new ApClassFrontendService(useApClassApi());
